//Referral - Sales Routing Tab constants
export const OPPORTUNITY_OWNER_TO_ACCOUNT_OWNER_FOR_EXISTING_PROSPECT =
  "Set Opportunity Owner to Account Owner";
export const OPPORTUNITY_OWNER_TO_INTEGRATION_USER_FOR_EXISTING_PROSPECT =
  "Set Opportunity Owner to Integration User";
export const OPPORTUNITY_OWNER_TO_INTEGRATION_USER_FOR_NEW_PROSPECT =
  "Set Opportunity Owner to Integration User";
export const OPPORTUNITY_OWNER_IN_APPROVAL_WORKFLOW =
  "Manually Select Opportunity Owner in Approval Workflow";
